var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavFerry = function SvgNavFerry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M24 24.1c-1.8 0-1.8-.9-3.6-.9s-1.8.9-3.6.9-1.8-.9-3.6-.9-1.8.9-3.6.9-1.8-.9-3.7-.9-1.8.9-3.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m7.1 21.5.9-3h7.1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m22.1 21.5 2-8-2-9H4l-1.9 9 2 8"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M11.1 18.5h7l1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1 13.5h-13 4-13M22.6 8.5H11.1h4H3.6"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M13.1 1v3.5"
  }))));
};
export default SvgNavFerry;